import React, { useState } from "react";
import axios from "axios";

const API_BASE = process.env.REACT_APP_REPORTS_API_BASE || "https://oppiesfunc.azurewebsites.net";

// OPTION A: one unified endpoint you create:
const SEARCH_ALL = `${API_BASE}/api/searchModeration`; // GET q=, type=posts,comments, from=, to=, page=, pageSize=

// OPTION B: two endpoints (enable if you have them):
const SEARCH_POSTS = ""; // e.g. `${API_BASE}/api/modSearchPosts`
const SEARCH_COMMENTS = ""; // e.g. `${API_BASE}/api/modSearchComments`

const btn = (primary = false) => ({
    padding: "8px 12px", borderRadius: 8, border: primary ? "none" : "1px solid #ccc",
    background: primary ? "#bfa97c" : "#fff", color: primary ? "#fff" : "#333", cursor: "pointer", fontWeight: 600,
});
const input = { padding: "8px 10px", borderRadius: 8, border: "1px solid #ccc", fontSize: 14 };

export default function ModerationSearch() {
    const [q, setQ] = useState("");
    const [type, setType] = useState("posts,comments"); // posts | comments | both
    const [from, setFrom] = useState("");
    const [to, setTo] = useState("");
    const [loading, setLoading] = useState(false);
    const [items, setItems] = useState([]);
    const [error, setError] = useState("");
    const [open, setOpen] = useState(false);
    const [selected, setSelected] = useState(null);

    async function runSearch() {
        setLoading(true);
        setError("");
        setItems([]);
        try {
            if (SEARCH_ALL) {
                const res = await axios.get(SEARCH_ALL, { params: { q, type, from, to, page: 1, pageSize: 50 } });
                setItems(normalize(res.data?.items || []));
            } else {
                const calls = [];
                if (!type || type.includes("posts")) calls.push(axios.get(SEARCH_POSTS, { params: { q, from, to } }));
                if (!type || type.includes("comments")) calls.push(axios.get(SEARCH_COMMENTS, { params: { q, from, to } }));
                const results = await Promise.all(calls);
                const merged = results.flatMap(r => Array.isArray(r?.data?.items) ? r.data.items : (Array.isArray(r?.data) ? r.data : []));
                setItems(normalize(merged));
            }
        } catch (e) {
            console.error("[ModerationSearch] error:", e?.message || e);
            setError("Failed to search. Check endpoint(s) and CORS.");
        } finally {
            setLoading(false);
        }
    }

    return (
        <div>
            <h2 style={{ marginBottom: 10 }}>Moderation Search</h2>

            <div style={{
                display: "grid", gridTemplateColumns: "1fr 180px 180px 120px", gap: 8,
                background: "#fff", border: "1px solid #e7e0d6", borderRadius: 10, padding: 12, marginBottom: 12
            }}>
                <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Email, name, or ID " style={input} />
                <select value={type} onChange={(e) => setType(e.target.value)} style={input}>
                    <option value="posts,comments">Posts & Comments</option>
                    <option value="posts">Posts only</option>
                    <option value="comments">Comments only</option>
                </select>
                <input type="date" value={from} onChange={(e) => setFrom(e.target.value)} style={input} />
                <input type="date" value={to} onChange={(e) => setTo(e.target.value)} style={input} />
            </div>

            <div style={{ display: "flex", gap: 8, marginBottom: 12 }}>
                <button style={btn()} onClick={() => { setQ(""); setType("posts,comments"); setFrom(""); setTo(""); }}>Reset</button>
                <button style={btn(true)} onClick={runSearch}>Search</button>
            </div>

            {error && (
                <div style={{ background: "#fdecea", border: "1px solid #f5c2c7", color: "#7a1c1c", padding: 10, borderRadius: 8, marginBottom: 12 }}>
                    {error}
                </div>
            )}

            <div style={{ background: "#fff", border: "1px solid #e7e0d6", borderRadius: 10, overflow: "hidden" }}>
                <div style={{ padding: "10px 12px", borderBottom: "1px solid #eee", color: "#6b5b3a" }}>
                    {loading ? "Searching " : `Results: ${items.length}`}
                </div>
                <div style={{ overflowX: "auto" }}>
                    <table style={{ width: "100%", borderCollapse: "collapse" }}>
                        <thead>
                            <tr style={{ background: "#faf7f1" }}>
                                <Th>Type</Th>
                                <Th>Created</Th>
                                <Th>Author</Th>
                                <Th>Entity</Th>
                                <Th>Subject ID</Th>
                                <Th>Excerpt</Th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                <tr><td colSpan={6} style={{ padding: 18, textAlign: "center" }}>Loading </td></tr>
                            ) : items.length === 0 ? (
                                <tr><td colSpan={6} style={{ padding: 18, textAlign: "center", color: "#777" }}>No results.</td></tr>
                            ) : items.map((it) => (
                                <tr key={`${it.type}_${it.subjectId}`} style={{ borderTop: "1px solid #f1ece4", cursor: "pointer" }}
                                    onClick={() => { setSelected(it); setOpen(true); }}>
                                    <Td>{it.type}</Td>
                                    <Td>{formatDT(it.createdAt)}</Td>
                                    <Td>{it.authorName || it.authorEmail || " "}</Td>
                                    <Td>{it.entity?.storeId ? it.entity.storeId : it.entity?.shopId ? it.entity.shopId : " "}</Td>
                                    <Td><Mono>{it.subjectId}</Mono></Td>
                                    <Td>{it.excerpt || " "}</Td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>

            {open && selected && (
                <Drawer onClose={() => setOpen(false)}>
                    <h3 style={{ marginTop: 0 }}>{selected.type === "post" ? "Post" : "Comment"} Preview</h3>
                    <p><strong>Subject:</strong> <Mono>{selected.subjectId}</Mono></p>
                    <p><strong>Author:</strong> {selected.authorName || selected.authorEmail || " "}</p>
                    <p><strong>Entity:</strong> {selected.entity?.storeId || selected.entity?.shopId || " "}</p>
                    {selected.text && <div style={{ marginTop: 8, padding: 10, background: "#fafafa", borderRadius: 8, border: "1px solid #eee" }}>{selected.text}</div>}

                    <div style={{ display: "flex", gap: 10, marginTop: 16 }}>
                        <a href={selected.type === "post"
                            ? `/moderation/reports?q=${encodeURIComponent(selected.subjectId)}`
                            : `/moderation/reports?q=${encodeURIComponent(selected.subjectId)}`
                        }
                            style={{ ...btn(), textDecoration: "none", lineHeight: "32px" }}
                        >Open in Reports</a>
                        <div style={{ marginLeft: "auto" }} />
                        <button style={btn()} onClick={() => setOpen(false)}>Close</button>
                    </div>
                </Drawer>
            )}
        </div>
    );
}

function normalize(items) {
    // Coerce different shapes into a unified row model.
    return items.map(x => ({
        type: (x.type || x.subjectType || x.kind || "").toString().toLowerCase().includes("comment") ? "comment" : "post",
        subjectId: x.subjectId || x.id || x.postId || x.commentId || "",
        createdAt: x.createdAt || x.timestamp || x.date || "",
        authorEmail: x.authorEmail || x.email || x.userEmail || "",
        authorName: x.authorName || x.userName || x.name || "",
        entity: x.entity || (x.storeId ? { storeId: x.storeId } : (x.shopId ? { shopId: x.shopId } : undefined)),
        text: x.text || x.body || x.content || "",
        excerpt: (x.text || x.body || x.content || "").slice(0, 120),
    }));
}

function Th({ children }) {
    return <th style={{ textAlign: "left", fontSize: 12, color: "#6b5b3a", padding: "10px 12px" }}>{children}</th>;
}
function Td({ children }) {
    return <td style={{ padding: "10px 12px", fontSize: 14, color: "#333" }}>{children}</td>;
}
function Mono({ children }) {
    return <span style={{ fontFamily: "ui-monospace, SFMono-Regular, Menlo, Consolas, monospace" }}>{children}</span>;
}
function Drawer({ children, onClose }) {
    return (
        <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.35)", zIndex: 40, display: "flex", justifyContent: "flex-end" }}
            onClick={(e) => { if (e.target === e.currentTarget) onClose?.(); }}>
            <div style={{
                width: "min(520px, 95vw)", height: "100%", background: "#fff",
                padding: 16, overflowY: "auto", boxShadow: "-8px 0 24px rgba(0,0,0,0.15)"
            }}>
                {children}
            </div>
        </div>
    );
}
function formatDT(iso) {
    if (!iso) return " ";
    try { return new Date(iso).toLocaleString(); } catch { return iso; }
}
